module.exports = __webpack_public_path__ + "img/about_believe_backgroun.f95aed3e.png";